module.exports = __webpack_public_path__ + "static/media/fast-time.95af066d.svg";